import { Access, Info } from "@/services/apiTypes";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

let token: string | null = null;

// Export for testing
export const clearToken = () => {
  token = null;
};

export const checkToken = () => {
  if (token) {
    return token;
  }

  // check the url for a token
  const url = new URL(window.location.href);
  const urlToken = url.searchParams.get("t");
  if (urlToken) {
    sessionStorage.setItem("token", urlToken);
    token = urlToken;
    return urlToken;
  }

  // check the session storage for a token
  const sessionToken = sessionStorage.getItem("token");
  if (sessionToken) {
    token = sessionToken;
    return token;
  }

  console.error("No token found");

  return null;
};

// call ensureToken on page load to try and grab it from the url
checkToken();

export const prepareHeaders = (headers: any) => {
  const token = checkToken();
  if (token) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  return headers;
};

export const baseQuery = fetchBaseQuery({
  baseUrl: `${import.meta.env.VITE_LIGHT_BASE_API}/portal/v1`,
  prepareHeaders,
});
export const api = createApi({
  reducerPath: "api",
  baseQuery,
  endpoints: (builder) => ({
    info: builder.query<Info, void>({
      query: () => ({
        url: "/info",
        method: "GET",
      }),
    }),

    access: builder.mutation<Access, void>({
      query: (body) => ({
        url: "/access",
        method: "POST",
        body,
      }),
    }),

    emailAccessToken: builder.mutation<void, void>({
      query: (body) => ({
        url: "/email-access-token",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useInfoQuery, useAccessMutation, useEmailAccessTokenMutation } =
  api;
